export default {
  key: "user_log",
  sort: {
    field: "user_log_id",
    order: "desc"
  },
  fields: [
    { key: "user_log_id" },
    { key: "type" },
    { key: "msg" },
    { key: "ip" },
    { key: "user_id", field: "user_id.name" },
    { key: "cre_dttm", type: "datetime" },
  ],
  filters: {
    user_id: {
      type: "select"
    }
  },
  options: {
    user_id: {
      key: "users",
      label: "name",
      value: "username"
    }
  }
}